/**
 * Planning ⇄ Execute — the global density switch for Task and Routine cards, and nothing
 * else (§11's clutter pass: badges stay put in both modes, only buttons move).
 *
 * Lives in the nav beside the arrange lock, for the same reason that one does: cards are
 * portable across pages (D111), so there is no single card-adjacent spot guaranteed to sit
 * near every Task or Routine card at once — the nav is the one place that's always on
 * screen regardless of layout. Unlike the arrange lock, this persists across a reload
 * (`settings.ts`'s `cardMode`) rather than resetting each session: switching modes is a
 * repeated, deliberate choice between two ways of using the app, not a temporary state you
 * expect to fall out of.
 */

import { Bolt, SetSquare } from "./icons";
import { saveSetting, useSettings } from "../settings";

export function CardModeToggle() {
  const { cardMode } = useSettings();
  const planning = cardMode === "plan";

  return (
    <button
      type="button"
      className={`card-mode-toggle${planning ? "" : " execute"}`}
      onClick={() => saveSetting("cardMode", planning ? "execute" : "plan")}
      aria-pressed={planning}
      title={
        planning
          ? "Planning - every button visible. Click for Execute."
          : "Execute - just tick, star, skip. Click for Planning."
      }
    >
      {planning ? <SetSquare size={16} /> : <Bolt size={16} />}
      <span className="sr-only">{planning ? "Switch to Execute mode" : "Switch to Planning mode"}</span>
    </button>
  );
}
